<template>
	<div class="project">
		<div class="header">
			<div class="container">
				<div class="flex">
					<a class="logo"><img src="../../image/zsdb_logo.png" class="logoImg" style="width:132px"></a>
					<div class="menu" id="nav">
						<ul>
							<li class="menulist"><a @click="gotoHome()" class="">首页</a></li>
							<li class="menulist"><a @click="gotoCampus()" class="">校园招聘</a></li>
							<li class="menulist"><a @click="gotoSociety()" class="">社会招聘</a></li>
							<li class="menulist"><a @click="gotoIntern()" class="">实习生招聘</a></li>
							<li class="menulist"><a @click="gotoAboutus()" class="on">关于我们</a></li>
						</ul>
					</div>
					<div class="user">
						<div v-show="islogin" class="isLogin" style="display: none;">
							<div @click="gotopersonal()" style="cursor: pointer;"><span>个人中心</span></div>
							<span class="divider">|</span>
							<div @click="exit()" style="cursor: pointer;"><span> 退出</span></div>
						</div>
						<div v-show="unlogin" class="unLogin" style="display: none;">
							<div @click="gotologin()" style="cursor: pointer;"><span>登录</span></div>
							<span class="divider">|</span>
							<div @click="gotoregister()" style="cursor: pointer;"><span>注册</span></div>
						</div>
					</div>
					<el-popover class="ewm" trigger="hover" placement="bottom">
						<img src="../../image/ewm.jpg" class="code">
						<img src="../../image/icoewm.png" slot="reference" class="ico">
					</el-popover>

				</div>
			</div>
		</div>
		<div class="pagesbanner"
			style="background: url(//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_bannergy.jpg) top center no-repeat;">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh01.png"
				class="dh wow  fadeInLeft" style="left: 0">
			<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_gydh02.png"
				class="dh wow  fadeInLeft" style="right: 0">
			<div class="text">
				<h3>关于我们</h3>
				<p>ABOUT US</p>
			</div>
		</div>
		<div class="pagesabout">
			<div class="container">
				<div class="flex">
					<div class="aboutleft">
						<div class="item">
							<a @click="gotoAboutus()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico1on.png"
										class="icoon"></span>
								公司介绍
							</a>
						</div>
						<div class="item on ">
							<a @click="gotoProject()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico2on.png"
										class="icoon"></span>
								典型工程
							</a>
						</div>
						<div class="item ">
							<a @click="gotoCulture()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico3on.png"
										class="icoon"></span>
								人才培养
							</a>
						</div>
						<div class="item ">
							<a @click="gotoLife()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico4on.png"
										class="icoon"></span>
								园区生活
							</a>
						</div>
						<div class="item ">
							<a @click="gotoRecruit()" style="cursor: pointer;">
								<span><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5.png"
										class="ico"><img
										src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_aico5on.png"
										class="icoon"></span>
								招聘Q&A
							</a>
						</div>

					</div>
					<div class="aboutright">
						<div class="abouttitle">
							<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dd.png"
								class="ico">典型工程
						</div>
						<div class="dxgc">
							<div class="lunbo">
								<div class="swiper-container swiper-gongcheng">
									<div class="swiper-wrapper">
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dxgc_3.png">
											<p>世界第二大水电站——白鹤滩水电站</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dxgc_8.png">
											<p>国内首个300MW海上风电EPC项目——江苏竹根沙（H2)</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dxgc_6.png">
											<p>杭州亚运会“乒乓球、霹雳舞”馆</p>
										</div>

										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dxgc_5.png">
											<p>浙江省首个国家重大科技基础设施——国家实验室超重力离心模拟实验装置</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dxgc_9.png">
											<p>杨公堤综合整治工程</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dxgc_7.png">
											<p>国内规模最大的水环境EPC项目——深圳茅洲河综合整治工程</p>
										</div>
										<div class="swiper-slide">
											<img
												src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_dxgc_2.png">
											<p>全球规模最大的水下升降舞台——G20水下升降舞台</p>
										</div>
									</div>
								</div>
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_zjt.png"
									class="swiper-gongcheng-prev">
								<img src="//stc-cms.beisen.com/cmsportal/10648100/10648100_themes_huadongyuan2022_img_yjt.png"
									class="swiper-gongcheng-next">
							</div>
							<div class="text2">
								秉承“为客户创造价值，与合作方共同发展”的理念，华东院在水电、新能源、建筑与景观、交通与市政、水环境与水务、海洋工程及数字化信息化领域打造了一大批精品工程。</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<backtop></backtop>
	</div>
</template>

<script>
	import backtop from "../../components/backtop.vue"
	import {
		loginstatus,
		Logout,
	} from '../../api/user.js'
	// @ is an alias to /src
	export default {
		components: {
			backtop,
		},
		data() {
			return {
				value1: '',
				islogin: false,
				unlogin: false,
			}
		},

		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					this.islogin = true;
					this.unlogin = false;
				} else if (res.code != 200) {
					this.islogin = false;
					this.unlogin = true;
				}
			})
		},
		methods: {
			exit() {
				Logout().then((res) => {
					location.reload()
				})
			},
			gotologin() {
				this.$router.push('/login')
			},
			gotoregister() {
				this.$router.push('/register')
			},
			gotoHome() {
				this.$router.push('/')
			},
			gotoAboutus() {
				this.$router.push('/aboutus/introduce')
			},
			gotoCampus() {
				this.$router.push('/campus')
			},
			gotoSociety() {
				this.$router.push('/society')
			},
			gotoIntern() {
				this.$router.push('/intern')
			},
			// gotoProject() {
			// 	this.$router.push('/aboutus/project')
			// },
			gotoCulture() {
				this.$router.push('/aboutus/culture')
			},
			gotoLife() {
				this.$router.push('/aboutus/life')
			},
			gotoRecruit() {
				this.$router.push('/aboutus/recruit')
			},
			gotopersonal() {
				this.$router.push('/personal/resume')
			},
		}
	}
</script>

<style scoped>
	@import url(../../assets/css/index.css);
</style>
